<div class="container main-content mt-5 pt-5 col-lg-10 col-md-10 col-12">
  <div class="custom-card">
    <div class="card-body">
      <div class="row align-items-center mb-3 d-flex justify-content-between">
        <h2 class="custom-card-title headLeft">Annual School Profiles</h2>
        <!-- Search -->
        <div class="col-12 col-md-5 mb-3 headLeft">
          <input type="text" class="form-control" placeholder="Search annual school profiles..."
                 [(ngModel)]="searchValue"
                 (ngModelChange)="filter(searchValue)">
        </div>

        <select *ngIf="teacher?.role === 'Admin'" class="form-select mb-3" (change)="showProfile($event)">
          <option disabled>Admin Filter</option>
          <option selected value="All Profiles">All Profiles</option>
          <option value="Deleted">Deleted</option>
          <option value="Active">Active</option>
        </select>

        <div class="col-12 col-md-5 mb-3 d-flex justify-content-md-end gap-2 headRight">
          <div>
            <!-- Create New Profile Button -->
            <a routerLink="/annual-school-profiles-form" class="btn btn-primary d-flex align-items-center"
               *ngIf="teacher?.role !== 'Science Directors'">
              New Profile
              <span class="material-symbols-outlined ms-1">add</span>
            </a>
          </div>
          <select class="form-select" aria-label="Number of cards per page" (change)="selectChange($event)">
            <option selected value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="All">All</option>
          </select>
          <button class="btn btn-primary d-flex align-items-center"
                  (click)="exportCSV(schoolProfile,'AnnualSchoolProfiles.csv')" id="download">
            <span *ngIf="!downloadedTable" class="material-symbols-outlined me-1"
                  style="font-size: 1.2rem">download</span>
            <span *ngIf="downloadedTable" class="material-symbols-outlined me-1"
                  style="font-size: 1.2rem"> download_done</span>
            Export Profiles
          </button>
        </div>

        <div class="row" style="margin: 0" id="row-section">
          <div class="col-12">
            <table class="table">
              <thead>
              <tr>
                <th (click)="sort('school')">
                  School Name
                  <span *ngIf="getSortDir('school') === 'asc'"
                        class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
                  <span *ngIf="getSortDir('school') === 'desc'" class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
                  <span *ngIf="getSortDir('school') !== 'desc' && getSortDir('school') !== 'asc'"
                        class="material-symbols-outlined">swap_vert</span>
                </th>
                <th (click)="sort('year')">
                  Year
                  <span *ngIf="getSortDir('year') === 'asc'"
                        class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
                  <span *ngIf="getSortDir('year') === 'desc'"
                        class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
                  <span *ngIf="getSortDir('year') !== 'desc' && getSortDir('year') !== 'asc'"
                        class="material-symbols-outlined">swap_vert</span>
                </th>
                <th (click)="sort('cluster')">
                  Cluster
                  <span *ngIf="getSortDir('cluster') === 'asc'"
                        class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
                  <span *ngIf="getSortDir('cluster') === 'desc'" class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
                  <span *ngIf="getSortDir('cluster') !== 'desc' && getSortDir('cluster') !== 'asc'"
                        class="material-symbols-outlined">swap_vert</span>
                </th>
                <th (click)="sort('ghs')">
                  GHS Teacher Rep
                  <span *ngIf="getSortDir('ghs') === 'asc'"
                        class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
                  <span *ngIf="getSortDir('ghs') === 'desc'"
                        class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
                  <span *ngIf="getSortDir('ghs') !== 'desc' && getSortDir('ghs') !== 'asc'"
                        class="material-symbols-outlined">swap_vert</span>
                </th>
                <th (click)="sort('date')">
                  Created Date
                  <span *ngIf="getSortDir('date') === 'asc'"
                        class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
                  <span *ngIf="getSortDir('date') === 'desc'"
                        class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
                  <span *ngIf="getSortDir('date') !== 'desc' && getSortDir('date') !== 'asc'"
                        class="material-symbols-outlined">swap_vert</span>
                </th>
                <th (click)="sort('updatedDate')">
                  Updated Date
                  <span *ngIf="getSortDir('updatedDate') === 'asc'" class="material-symbols-outlined ms-1">keyboard_arrow_up</span>
                  <span *ngIf="getSortDir('updatedDate') === 'desc'" class="material-symbols-outlined ms-1">keyboard_arrow_down</span>
                  <span *ngIf="getSortDir('updatedDate') !== 'desc' && getSortDir('updatedDate') !== 'asc'"
                        class="material-symbols-outlined">swap_vert</span>
                </th>
              </tr>
              </thead>
              <tbody *ngIf="pagedCards.length > 0; else noSchoolProfile">
              <ng-container *ngFor="let profile of pagedCards; let i = index">
                <!-- Main Row -->
                <tr>
                  <td (click)="onCardClicked(profile)"
                      (mouseenter)="hoveredRow = i"
                      (mouseleave)="hoveredRow = null"
                      style="cursor:pointer;">
                    {{ profile.school }}
                  </td>
                  <td>{{ profile.schoolYear }}</td>
                  <td>{{ getClusterForSchool(profile.school) }}</td>
                  <td>{{ profile.ghsRepresentativeName }}</td>
                  <td>{{ profile.submissionDate | date:'MMM d, yyyy' }}</td>
                  <td>{{ profile.editedDate | date:'MMM d, yyyy' }}</td>
                </tr>

                <!-- Hover Card -->
                <tr *ngIf="hoveredRow === i">
                  <td colspan="6" class="p-0">
                    <div class="p-3 m-0">
                      <app-annual-school-profiles-card
                        [schoolName]="profile.school"
                        [year]="profile.schoolYear"
                        [teacherName]="profile.ghsRepresentativeName"
                        [project]="profile.project"
                        (cardClicked)="onCardClicked(profile)">
                      </app-annual-school-profiles-card>
                    </div>
                  </td>
                </tr>
              </ng-container>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Pagination (only if more than one page) -->
        <ul class="pagination headLeft" *ngIf="totalPages > 1">
          <li class="page-item" [class.disabled]="currentPage === 1">
            <a class="page-link" (click)="goToPrevious()">Previous</a>
          </li>

          <li
            *ngFor="let page of pages"
            class="page-item"
            [class.active]="page === currentPage"
          >
            <a class="page-link" (click)="goToPage(page)">{{ page }}</a>
          </li>

          <li class="page-item" [class.disabled]="currentPage === totalPages">
            <a class="page-link" (click)="goToNext()">Next</a>
          </li>
        </ul>

        <ng-template #noSchoolProfile>
          <div class="col-12">
            <p class="mb-4">There are no annual school profiles.</p>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

